// Global Instructions Rule Applied!
import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { PIPELINE_TYPE_DEAL_ORIGINATION } from '../../../state_manager/globals.ts'

/**
 * Deal types barred from Deal Origination (cfg.pipeline_deal_type_exclusions,
 * managed in Configuration → Deal Origination). Such a deal never joins the
 * origination board, so the deal forms do not offer a Pipeline Stage for it:
 * the New Deal drawer would promise a stage the backend discards, and on an
 * existing deal the read returns the execution row, whose stage the
 * origination-only option list cannot label (it rendered the raw config uuid).
 */
export function useOriginationExcludedDealType(): (dealTypeId?: string | null) => boolean {
  const dealTypeExclusions = useSelector((state: any) => state.globalConfigs?.pipeline_deal_type_exclusions || [])

  const excludedDealTypeIds = useMemo(() => {
    return new Set(
      (dealTypeExclusions as any[])
        .filter((row) => row?.pipeline_type_id === PIPELINE_TYPE_DEAL_ORIGINATION)
        .map((row) => row?.deal_type_id)
        .filter(Boolean)
    )
  }, [dealTypeExclusions])

  return useCallback(
    (dealTypeId?: string | null) => !!dealTypeId && excludedDealTypeIds.has(dealTypeId),
    [excludedDealTypeIds]
  )
}
